import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import moment from 'moment';
import 'moment/locale/pt-br';
import React from 'react';
import { downloadFile } from 'utils/downloadFile';
import { formatDateRange } from 'utils/formatDateRange';
import { useStoreSelector } from 'v3/data/store';
import { PeriodAndGroupInfo } from 'v3/pages/SellersRanking/Header/PeriodAndGroupInfo';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';
import { theme } from 'v3/styles/global-styles';
import { AlignText, CustomLabelSmall, LeftContent, RightContent, Wrapper } from './styles';

moment.locale('pt-br');

export const SellersInfor: React.FC = () => {
  const { report } = useStoreSelector((store) => store.rankSeller);

  const handleDownload = () => {
    if (report.url) {
      downloadFile(report.url);
    }
  };

  const hasDowloadLink = Boolean(report.url) && report.status === 'COMPLETED' && report.startDate && report.finalDate;

  return (
    <Wrapper>
      <LeftContent>
        <HeadlineMedium>Ranking de consultores</HeadlineMedium>
        <SubtitleLarge color={theme.palette.secondary.light}>
          Importante! Você está visualizando as informações de todos os parceiros
        </SubtitleLarge>
        {hasDowloadLink && (
          <AlignText>
            <TitleSmall>
              Último relatório gerado: {formatDateRange(report.startDate)} – {formatDateRange(report.finalDate)}.
            </TitleSmall>
            <CustomLabelSmall onClick={handleDownload}>
              Baixar último relatório
              <FileDownloadOutlinedIcon fontSize="small" style={{ color: theme.palette.warning.main }} />
            </CustomLabelSmall>
          </AlignText>
        )}
      </LeftContent>

      <RightContent>
        <PeriodAndGroupInfo />
      </RightContent>
    </Wrapper>
  );
};

export default SellersInfor;
